var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftarrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4818 7.47296L9.38553 13.2922C9.03915 13.6039 8.51957 13.6039 8.20783 13.2575C7.89609 12.9112 7.89609 12.3916 8.24247 12.0798L12.8493 7.68079H1.07237C0.587434 7.68079 0.241053 7.33441 0.241053 6.84947C0.241053 6.39918 0.587434 6.01816 1.07237 6.01816H12.8493L8.24247 1.65375C7.89609 1.34201 7.89609 0.787796 8.20783 0.476052C8.51957 0.129671 9.07378 0.129671 9.38553 0.441414L15.4818 6.26062C15.655 6.43382 15.7589 6.64164 15.7589 6.84947C15.7589 7.09194 15.655 7.29977 15.4818 7.47296Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftarrow);
export default __webpack_public_path__ + "static/media/leftarrow.28fb4113710fef5fd6565c693e6af43d.svg";
export { ForwardRef as ReactComponent };